import { REGISTER_STEPS_TYPES } from '@namespace/auth';
import PersonalInfo from './PersonalInfo';
import SecretQuestions from './SecretQuestion';
import Welcome from './Welcome';

export const registerStepsMap = {
  [REGISTER_STEPS_TYPES.WELCOME]: Welcome,
  [REGISTER_STEPS_TYPES.PERSONAL_INFO]: PersonalInfo,
  [REGISTER_STEPS_TYPES.SECRET_QUESTION]: SecretQuestions
};
